import ButtonBase from "@mui/material/ButtonBase";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import { PublicSvgIcon } from "~/components/public_svg_icon";
import { useAuthStatus } from "~/contexts/auth_query";

export function KycUserMenu() {
  const { user, logout } = useAuthStatus();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = anchorEl !== null;
  const email = user?.profile?.email ?? "";

  return (
    <>
      <ButtonBase
        aria-haspopup="menu"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        data-testid="kyc-user-menu-button"
        sx={{ gap: 1, color: "common.white", minWidth: 0 }}
      >
        <Typography
          variant="body2"
          noWrap
          sx={{ typography: { xs: "body3", lg: "body2" }, fontWeight: 700 }}
        >
          {email}
        </Typography>
        <PublicSvgIcon
          name="expand_more"
          inheritColor
          sx={{ transform: isOpen ? "rotate(180deg)" : "none" }}
        />
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { width: 187, mt: 0.25 } },
          list: { sx: { pb: 0.5 } },
        }}
      >
        <Stack sx={{ px: 2, pt: 0.25, pb: 1, gap: 0.5 }}>
          <Typography variant="body4" color="text.secondary">
            Signed in as
          </Typography>
          <Typography variant="body3" noWrap>
            {email}
          </Typography>
        </Stack>
        <Divider sx={{ my: 0 }} />
        <MenuItem onClick={logout} data-testid="kyc-logout-button">
          <Typography variant="body3">Log out</Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
